export const polygonReferenceLayerId = '_reference'; // all visualized layers will be rendered on top of this one
export const POINTS_LAYER_MIN_ZOOM = 6;
